<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-3 h-3 text-black"
  >
    <title>Banks</title>
    <path d="M3 10h18M5 10v8m4-8v8m4-8v8m4-8v8M2 10l10-6 10 6" 
          stroke="currentColor"
          fill="none"
          stroke-width="2"/>
  </svg>
</template>
